module.exports = __webpack_public_path__ + "static/media/1998-Graubner-0.8e72e457.jpg";